import { matchPath } from 'react-router';
import nonSignedInPageRoutes, {
  authorizedPages,
  pagesWithLpHeader,
} from '../config/nonSignedInPageRoutes';

export const isAuthorizedPage = (pathname) => authorizedPages.some((path) => {
  const match = matchPath(pathname, {
    path,
  });

  return match?.path === path || pathname.includes(path);
});

export const shouldRenderHeader = (pathname) => pagesWithLpHeader.some((path) => {
  const match = matchPath(pathname, {
    path,
  });

  return match?.path === path || pathname?.includes(path);
});

export const hasAccessToAtleastOneTerm = (authorizedEntities) => {
  const terms = Object.keys(authorizedEntities);
  return terms.length > 1;
};

export const isANonSignedInPage = (pathname) => (pathname === '/'
  ? true
  : nonSignedInPageRoutes.some((path) => pathname.includes(path)));
